<template>
  <fin-work-in-progess-page title="Vergleiche Aktien"/>
</template>

<script>
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: "FinCompareShare",
  components: {FinWorkInProgessPage}
}
</script>

<style scoped>

</style>
